window.app.controller('userRegistrationCtrl', ['$http', '$scope', '$compile', function ($http, $scope, $compile){
    $scope.emailChecks = {};
    $scope.userMailAgentLink = '';
    
    $scope.firstStepShow = true;

    $scope.successStepShow = false;

    $scope.userEmail = $('input[name="email"]').attr('data-default-value');
    $scope.checkUserRegForm = function(resp){
        if(resp.data.registrationSuccess){
            $scope.firstStepShow = false;
            $scope.successStepShow = true;
        }
        else{
            console.log(resp.data.registrationSuccess);
            console.log('checkFirstForm ERROR');
            $scope.formErrorText = resp.data.message;
            $scope.formErrorLink = resp.data.link;
        }
    }
    
    $scope.sendUserRegForm = function(){
        $scope.formErrorText = '';
        $scope.formErrorLink = '';
        $scope.registration.type = 'user';
        $scope.registration.accept_terms = +$scope.registration.accept_terms;
        $scope.registration.accept_personal_data_terms = +$scope.registration.accept_personal_data_terms;
        $scope.registration.accept_mailing_policy = +$scope.registration.accept_mailing_policy;

        $scope.sendXHR({
            url: '/api/front/registration/registration/register',
            data: $scope.registration,
            successFunc: $scope.checkUserRegForm

        });
    }


    $scope.resendRegConfirmLetter = async (evt) => {
        // evt.preventDefault();

        try {
            // $scope.switchLoader(true);
            const res = await $scope.sendMessage();
        } catch (err) {
            console.error(err);
        }

    };

    $scope.mailRedirect = function() {
        window.location.href = $scope.userMailAgentLink;
    };


    $scope.sendMessage = () => {
        return $http({
            method: 'POST',
            url: '/api/front/registration/registration/resend-letter',
            data: {
              type: 'user',
                email: $scope.registration.email
            }
        });
    };

}]);



// WEBPACK FOOTER //
// src/js/controllers/user/userRegistrationCtrl.js